import React from 'react';

export const PlayerAvatar = ({ player, jerseyNumber, size = 40 }) => {
  const imgSrc = player?.photo_url || '/images/avatars/default-player.png';
  const initials = `${(player?.first_name || '')[0] || ''}${(player?.last_name || '')[0] || ''}`.toUpperCase();
  const fallback = initials || `#${jerseyNumber}`;

  return (
    <>
      <img
        src={imgSrc}
        alt={`${player?.first_name || ''} ${player?.last_name || ''}`}
        className="rounded-full object-cover flex-shrink-0"
        style={{ width: size, height: size }}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
      <div
        className="rounded-full bg-gray-600 items-center justify-center flex-shrink-0 text-gray-300 font-bold"
        style={{ width: size, height: size, fontSize: size * 0.35, display: 'none' }}
      >
        {fallback}
      </div>
    </>
  );
};
